import * as S from './ExamMockTestResult.styles';
import { Tabs, TabPane } from '@app/components/common/Tabs/Tabs';
import { useEffect, useState } from 'react';
import { TableProps, Tag } from 'antd';
import { convertTypeParctice, statusType } from '@app/utils/utils';
import { getResultDetail, IResultDetail } from '@app/api/result.api';
import { notificationController } from '@app/controllers/notificationController';
import { TableResultCollapse } from '../../components/TableResultCollapse';
import { useTranslation } from 'react-i18next';

interface IExamMockTestResultProps {
  mockTestUserId: string;
}

export interface IDataTypeResult {
  key: string;
  type: string;
  marks: number;
  status: string;
}

export const ExamMockTestResult: React.FC<IExamMockTestResultProps> = ({ mockTestUserId }) => {
  const { t } = useTranslation();
  const [columns, setColumns] = useState<TableProps<IResultDetail>['columns']>([]);

  const [resultLists, setResultLists] = useState<{
    speakingList: IResultDetail[];
    writingList: IResultDetail[];
    readingList: IResultDetail[];
    listeningList: IResultDetail[];
  }>({
    speakingList: [],
    writingList: [],
    readingList: [],
    listeningList: [],
  });

  useEffect(() => {
    if (mockTestUserId) fetchMockTestResult();
  }, [mockTestUserId]);

  useEffect(() => {
    setColumns([
      { title: '#', dataIndex: 'index', key: 'index', render: (_: any, __: any, index: number) => index + 1 },
      {
        title: t('page.results.type'),
        dataIndex: 'questionType',
        key: 'questionType',
        render: (questionType: string) => convertTypeParctice(questionType),
      },
      {
        title: t('page.results.status'),
        dataIndex: 'status',
        key: 'status',
        render: (status: string) => (
          <Tag color={statusType[status]} key={status}>
            {status ? t(`page.results.statusType.${status}`) : ''}
          </Tag>
        ),
      },
      {
        title: t('page.results.totalScore'),
        dataIndex: 'score',
        key: 'score',
      },
    ]);
  }, [t]);

  const fetchMockTestResult = async () => {
    try {
      const res = await getResultDetail(mockTestUserId);

      const groupedResults = res.reduce(
        (acc, item) => {
          if (item.questionType.startsWith('SPEAKING')) {
            acc.speakingList.push(item);
          } else if (item.questionType.startsWith('WRITING')) {
            acc.writingList.push(item);
          } else if (item.questionType.startsWith('READING')) {
            acc.readingList.push(item);
          } else if (item.questionType.startsWith('LISTENING')) {
            acc.listeningList.push(item);
          }
          return acc;
        },
        { speakingList: [], writingList: [], readingList: [], listeningList: [] } as {
          speakingList: IResultDetail[];
          writingList: IResultDetail[];
          readingList: IResultDetail[];
          listeningList: IResultDetail[];
        },
      );

      setResultLists(groupedResults);
    } catch (error) {
      notificationController.error({
        message: error,
      });
    }
  };

  return (
    <S.Wrapper>
      <S.CardHeader>
        <S.CardHeaderLeft>
          {/* <p className="mb-2">
            Email: <b>your@gmail.com</b>
          </p>
          <p className="mb-2">
            Created date: <b>16/12/2024, 07:49:16</b>
          </p>
          <p className="mb-2">
            Exam: <b>MOCK 14 - 2 HOURS</b>
          </p> */}
        </S.CardHeaderLeft>
        <S.CardHeaderRight>
          <img src="/images/finished.png" width={100} alt="finished" />
        </S.CardHeaderRight>
      </S.CardHeader>

      <Tabs defaultActiveKey="1">
        <TabPane tab={t('common.speaking')} key="1">
          <TableResultCollapse columns={columns} dataSource={resultLists.speakingList} />
        </TabPane>
        <TabPane tab={t('common.writing')} key="2">
          <TableResultCollapse columns={columns} dataSource={resultLists.writingList} />
        </TabPane>
        <TabPane tab={t('common.reading')} key="3">
          <TableResultCollapse columns={columns} dataSource={resultLists.readingList} />
        </TabPane>
        <TabPane tab={t('common.listening')} key="4">
          <TableResultCollapse columns={columns} dataSource={resultLists.listeningList} />
        </TabPane>
      </Tabs>
    </S.Wrapper>
  );
};
